import store from '@/store'

const hasAccessRechercheAdherent = function () {
  const roleUser = store.getters['user/profil'].roles
  const rolesAccessRechercheAdherent = ['CULTURIAL_LECTURE_PORTEFEUILLE', 'CULTURIAL_LECTURE_REGION', 'CULTURIAL_LECTURE_TOUS_ADHERENTS']
  return roleUser.some(r => rolesAccessRechercheAdherent.includes(r))
}

const isUtilisateurAgrial = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_AGRIAL')
}

const hasAllWriteAccess = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_TOUS_ADHERENTS')
}

const hasPersoWriteAccess = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_PERSO')
}

const hasDTEWriteAccess = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_DTE')
}

const hasDroitEcritureParametresCompte = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_PARAM_COMPTE')
}

const hasPortefeuilleWriteAccess = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_PORTEFEUILLE')
}

const hasCulturesWriteAccess = function () {
  return hasPersoWriteAccess() || hasPortefeuilleWriteAccess() || hasAllWriteAccess()
}

const hasParamCulturialWriteAccess = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_ADMIN_DTE')
}

const hasAccessAdminParamApplication = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_PARAM_APPLICATION')
}

const hasDroitEcritureAdminDte = function () {
  const roleUser = store.getters['user/profil'].roles
  return roleUser.includes('CULTURIAL_ECRITURE_ADMIN_DTE')
}

export default {
  hasAccessRechercheAdherent,
  hasPortefeuilleWriteAccess,
  isUtilisateurAgrial,
  hasAllWriteAccess,
  hasPersoWriteAccess,
  hasDroitEcritureParametresCompte,
  hasDroitEcritureAdminDte,
  hasDTEWriteAccess,
  hasAccessAdminParamApplication,
  hasParamCulturialWriteAccess,
  hasCulturesWriteAccess
}
